import { useGetApiV3BalanceQuery } from '#adapter/api/campaigns/v3/balance';

import { useSupplierFetch } from './use-supplier-fetch';

interface IProps {
    refetchOnMountOrArgChange?: boolean,
    refetchOnFocus?: boolean
}

export const useBalanceFetch = ({ refetchOnMountOrArgChange = false, refetchOnFocus = false }: IProps = {}) => {
    const { data: supplierData, isNoContract, isSpecial } = useSupplierFetch();

    const skip = !supplierData || isSpecial || isNoContract;

    const {
        data,
        isLoading,
        isFetching,
        error,
        refetch,
        isUninitialized
    } = useGetApiV3BalanceQuery({}, {
        skip,
        refetchOnMountOrArgChange,
        refetchOnFocus
    });

    return {
        data,
        error,
        isLoading,
        isFetching,
        refetch: isUninitialized ? undefined : refetch,
        isUninitialized,
        skip
    };
};
